<div class="d-flex flex-column">
    <div class="header-alignment">
        <p class="page-header" *ngIf="title.length == 1">
            {{title[0]}}
        </p>
        <p class="page-header" *ngIf="title.length == 2">
            <span class="link" [routerLink]="['/'+route]" >
                {{title[0]}}
            </span>
            <span>
                {{'/ ' + title[1]}}
            </span>
        </p>
        <p class="page-header" *ngIf="title.length == 3">
            <span class="link" [routerLink]="[route]">
                {{title[0]}}
            </span>
            <span>
                {{'/ ' + title[1]}}
            </span>
            <span>
                {{'/ ' + title[2]}}
            </span>
        </p>
        <button *ngIf="showRefresh" class="refresh-icon" (click)="fnRefreshPage()" [title]="tooltip">
            <i class="fa fa-refresh"  [ngClass]="{'fa-spin': utilsService.rotateIcon}"></i>
        </button>
    </div>
    <div class="desc-guide">
        <p *ngIf="description" class="description">
            {{ description }}
        </p>
        <span *ngIf="showUserGuide" class="user-guide">
            <img src="./assets/icons/pdf.svg" alt="PDF" width="25px" />
            <p (click)="fnOpenPdf()" class="guide mb-0" [title]="pdfTitle">{{pdfLabel}}</p>
        </span>
    </div>
</div>